import { FC, Ref } from 'react';
import NumberFormat from 'react-number-format';

const PercentageFormat: FC<{
    inputRef?: Ref<any>;
    name?: string;
    onChange?: any;
    min?: number;
    max?: number;
}> = (props) => {
    const { inputRef, onChange, min = 0, max = 100, ...other } = props;
    return <NumberFormat
        {...other}
        onChange={undefined}
        getInputRef={inputRef}
        onValueChange={(values) => {
            if (!onChange) return;

            if (values.value === undefined || values.value === '') {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
                return;
            }

            const number = Number(values.value);

            if (number <= min) {
                onChange({
                    target: {
                        name: props.name,
                        value: min.toString(),
                    },
                });
            } else if (number >= max) {
                onChange({
                    target: {
                        name: props.name,
                        value: max.toString(),
                    },
                });
            } else {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }
        }}
    />
}

export default PercentageFormat;
